<template>
  <div v-if="agency.assignedIndustries.length > 0 || agency.assignedFeatures.length > 0" class="py-6">
    <div class="flex items-start justify-between pb-12">
      <div>
        <div class="text-headline-xs" data-testid="industries-and-services-title">
          {{ t('Reviews.agency.view.industriesAndServices.label') }}
        </div>
        <div class="pt-2 text-body-s" data-testid="industries-and-services-description">
          {{ t('Reviews.agency.view.industriesAndServices.description') }}
        </div>
      </div>
      <OpenAgencyProfile class="shrink-0" :slug="agency.slug" />
    </div>
    <div class="text-headline-xs" data-testid="agency-industries-title">
      {{ t('Reviews.agency.view.industriesAndServices.industries.label') }}
    </div>
    <ul v-if="agency.assignedIndustries.length > 0" class="list-['-_'] pt-6 pb-12 pl-2 text-body-m" data-testid="agency-industries-list">
      <li v-for="assignedIndustry in agency.assignedIndustries" :key="assignedIndustry.industry.id" class="pb-3.5">
        {{ assignedIndustry.industry.name }}
      </li>
    </ul>
    <div v-else class="pt-2 pb-12">
      {{ t('Reviews.agency.view.industriesAndServices.industries.empty') }}
    </div>

    <div class="text-headline-xs" data-testid="agency-services-title">
      {{ t('Reviews.agency.view.industriesAndServices.services.label') }}
    </div>
    <FeaturesByCategoriesView v-if="agency.assignedFeatures.length > 0" class="pt-6" :assigned-features="agency.assignedFeatures" />
    <div v-else class="pt-2">
      {{ t('Reviews.agency.view.industriesAndServices.services.empty') }}
    </div>
  </div>
  <ReviewsEmptyView
    v-else
    class="py-8"
    data-testid="no-industries-services-view"
    :title="t('Reviews.agency.view.industriesAndServices.emptyTitle')"
    :description="t('Reviews.agency.view.industriesAndServices.emptyInfo')"
    :action="{
      label: t('Reviews.agency.view.industriesAndServices.addIndustryOrService'),
      to: {
        name: ReviewsRouteName.ReviewsAgencyViewIndustriesAndServices,
        params: { agencyId: agency.id },
      },
      disabled: true,
    }"
  >
    <template #image>
      <NoIndustriesAndServicesIcon />
    </template>
  </ReviewsEmptyView>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import FeaturesByCategoriesView from '@/components/ReviewsAgenciesManagements/IndustriesAndServices/FeaturesByCategoriesView.vue'
import OpenAgencyProfile from '@/components/ReviewsAgenciesManagements/OpenAgencyProfile.vue'
import ReviewsEmptyView from '@/components/ReviewsEmptyView.vue'
import type { AgencyData } from '@/gql/reviews'
import { ReviewsRouteName } from '@/router/types'

import NoIndustriesAndServicesIcon from './NoIndustriesAndServicesIcon.vue'

defineProps<{
  agency: AgencyData
}>()

const { t } = useI18n()
</script>
